module.exports = __webpack_public_path__ + "static/img/7.38a77d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/zh/7.png
// module id = RwZA
// module chunks = 0